import { LocalStorageService } from '@mm/utils/index';

const generate = () => crypto.getRandomValues(new Uint8Array(16)).join('');

interface Strategy {
  (): string;
}

export const LocalVar = ({
  name,
  strategy = generate,
}: {
  name: string;
  strategy?: Strategy;
}) => ({
  upsert() {
    let id = LocalStorageService.getItem(name);
    if (!id) {
      id = strategy();
      LocalStorageService.setItem(name, id);
    }
    return id;
  },
  generate() {
    return strategy();
  },
  set(v: string) {
    return LocalStorageService.setItem(name, v);
  },
  get() {
    return LocalStorageService.getItem(name);
  },
  remove() {
    LocalStorageService.removeItem(name);
  },
});
